import { useEffect, useState } from 'react';

export function useInitializeApis() {
  const [networkApi, setNetworkApi] = useState<string | null>(null);
  const [localizationApi, setLocalizationApi] = useState<string | null>(null);
  const [tokensApi, setTokensApi] = useState<string | null>(null);
  const [gasPriceApi, setGasPriceApi] = useState<string | null>(null);
  const [networkDescriptionApi, setNetworkDescriptionApi] = useState<string | null>(null);

  useEffect(() => {
    if (window.WP_API_SETTINGS) {
      setNetworkApi(window.WP_API_SETTINGS.api_network);
      setLocalizationApi(window.WP_API_SETTINGS.api_localization);
      setGasPriceApi(window.WP_API_SETTINGS.api_gasprice);
      setTokensApi(window.WP_API_SETTINGS.api_tokens);
      setNetworkDescriptionApi(window.WP_API_SETTINGS.api_network_description);
    }
  }, []);

  return { networkApi, localizationApi, tokensApi, gasPriceApi, networkDescriptionApi };
}
